import { View, Text, styled } from 'tamagui'
import type { ExploreCategory } from '@/types'

const FilterRow = styled(View, {
  flexDirection: 'row',
  gap: 6,
  flexWrap: 'wrap',
  paddingBottom: 8,
})

const Pill = styled(View, {
  paddingHorizontal: 12,
  paddingVertical: 6,
  borderRadius: '$borderRadius2xl',
  cursor: 'pointer',
  borderWidth: 1,
  borderColor: '$borderDefault',
  hoverStyle: {
    backgroundColor: '$sidebarHover',
  },
  // @ts-expect-error -- web transition
  style: { transition: 'background-color 150ms ease, border-color 150ms ease' },
  variants: {
    active: {
      true: {
        backgroundColor: '$accentLighter',
        borderColor: '$accent',
      },
    },
  } as const,
})

const PillText = styled(Text, {
  fontFamily: '$fontBody',
  fontSize: 13,
  fontWeight: '500',
})

const categories: { id: ExploreCategory; label: string; icon: string }[] = [
  { id: 'gaming', label: 'Gaming', icon: '🎮' },
  { id: 'technology', label: 'Technology', icon: '💻' },
  { id: 'education', label: 'Education', icon: '📚' },
  { id: 'music', label: 'Music', icon: '🎵' },
  { id: 'art', label: 'Art', icon: '🎨' },
  { id: 'science', label: 'Science', icon: '🔬' },
  { id: 'community', label: 'Community', icon: '🌐' },
  { id: 'privacy', label: 'Privacy', icon: '🔒' },
]

interface ExploreCategoryFilterProps {
  active: ExploreCategory | null
  onSelect: (category: ExploreCategory | null) => void
}

export function ExploreCategoryFilter({ active, onSelect }: ExploreCategoryFilterProps) {
  return (
    <FilterRow>
      <Pill
        active={active === null}
        onPress={() => onSelect(null)}
      >
        <PillText color={active === null ? '$accent' : '$sidebarMuted'}>All</PillText>
      </Pill>
      {categories.map((cat) => (
        <Pill
          key={cat.id}
          active={active === cat.id}
          onPress={() => onSelect(active === cat.id ? null : cat.id)}
        >
          <PillText color={active === cat.id ? '$accent' : '$sidebarMuted'}>
            {cat.icon} {cat.label}
          </PillText>
        </Pill>
      ))}
    </FilterRow>
  )
}
